module.exports = __webpack_public_path__ + "static/media/shamrock.056e1f65.png";